import { render, staticRenderFns } from "./CustomerSpecRow.vue?vue&type=template&id=1e4fa873&scoped=true&lang=pug&"
import script from "./CustomerSpecRow.vue?vue&type=script&lang=js&"
export * from "./CustomerSpecRow.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSpecRow.vue?vue&type=style&index=0&id=1e4fa873&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4fa873",
  null
  
)

export default component.exports